module.exports = __webpack_public_path__ + "img/16d004-12.3b5c3fe1.png";